import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ApiGo from '../../../actions/ApiGo'
import dataHandler_alert from '../../../actions/dataHandler_alert'
import { LogTime } from '../../../actions/forFrontEnd_Log'
import comm_imgs from '../../../comm_imgs'
import { SVGformat } from './SVGFunction'
import './_Print.scss'
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts'
import offlineExporting from "highcharts/modules/offline-exporting"


require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
offlineExporting(Highcharts)

const PrintPage =(props)=>{
    const {t} = useTranslation()
    const resident = props.data
    // const store_timestamp = useSelector(state=>state.store_historyData.timestamp)
    const timeNow = new LogTime().getFullTime_withoutMillsec()
    const timestp_today8am = calculateYesterday(Date.now())
    const date_today8am = new Date(timestp_today8am)
    const date_1dayago = new Date(timestp_today8am-86400000)
    const dateStr_1dayago = new LogTime(date_1dayago).getDate()
    const dateFull_1dayago = new LogTime(date_1dayago).getFullTime_withoutMillsec()
    const dateFull_today8am = new LogTime(date_today8am).getFullTime_withoutMillsec()

    const [alertArr, setAlertArr] = useState(Array(5).fill({}));
    const [breathArr, setBreathArr] = useState([]);
    const [breath, setBreath] = useState({});
    const [sleepArr, setSleepArr] = useState([]);
    const sleepTitle = [
        t('DASHBOARD.SLEEP_QUALITY'), t("HISTORY_RECORD.INBED_TIME"), t('HISTORY_RECORD.TOTAL_SLEEPING_TIME'),
        t('HISTORY_RECORD.SLEEP_LATENCY'), t("HISTORY_RECORD.ROLL"), t("HISTORY_RECORD.NIBTIMES"),
        t('HISTORY_RECORD.NIB'), t("HISTORY_RECORD.NIBMAX")
    ];
    const [alertCheck, setAlertCheck] = useState(false);
    const [breathCheck, setBreathCheck] = useState(false);
    const [sleepCheck, setSleepCheck] = useState(false);
    const [sleepInfoCheck, setSleepInfoCheck] = useState(false);

    const chartRef = useRef();

    useEffect(()=>{
        ApiGo.getAlert(resident.id, dateStr_1dayago, "ALL")
            .then(res => {
                let level2 = res.alerts.filter(res => res.bedStateAlertLevel===2)
                let af = alertFilter(level2)
                let ret = af.map(alert=>{
                    return [t(dataHandler_alert(2, alert[1]).msg), alert[0]+" "+t("GLOBAL.UNIT.TIMES")]
                })
                setAlertArr(ret)
                setAlertCheck(true)
            })
            .catch(() => {
                let af = alertFilter(alertArr)
                let ret = af.map(alert=>{
                    return [t(dataHandler_alert(2, alert[1]).msg), alert[0]+" "+t("GLOBAL.UNIT.TIMES")]
                })
                setAlertArr(ret)
                setAlertCheck(true)
            })
        ApiGo.getVital_Curve(resident.id, dateFull_1dayago, dateFull_today8am)
            .then(res => {
                setBreathArr(res)
                setBreathCheck(true)
            })
            .catch(() => { setBreathCheck(true) })
        ApiGo.getSleepQuality_ByResident(resident.id, dateStr_1dayago, dateStr_1dayago)
            .then(res => {
                setSleepArr(res.sleep_qualities)
                setSleepCheck(true)
                setSleepInfoCheck(true);
            })
            .catch(() => {
                setSleepCheck(true)
                setSleepInfoCheck(true);
            })
    }, [])

    useEffect(() => {
        if(breathArr===undefined){return}
        let avreage_breath_row = breathArr.map(row=>[dateStrToTimestamp(row.created_at), row.average])
        let ma_breath_row = breathArr.map(row=>[dateStrToTimestamp(row.created_at), row.moving_average])
        setBreath({
            chart: { type: 'line', zoomType:'xy', width: 500, height: 300 },
            title: { text: null },
            exporting: { fallbackToExportServer: false },
            xAxis: {
                type: 'datetime',
                labes:{ formatter: function() { return Highcharts.dateFormat('%H:%M', this.value);}}
            },
            yAxis: { title: { text: null }, min:0 },
            series: [{
                name: t("HISTORY_RECORD.AVG_BREATH_COUNT"),
                data: avreage_breath_row,
                color:"#B7DDE0",
                zIndex: 1
            },
            {
                name: t("HISTORY_RECORD.MA"),
                data: ma_breath_row,
                color:"#FFE652",
                zIndex: 1,
            }
            ]
        })
        function dateStrToTimestamp(_str){
            let _timeObj = new Date(_str)
            return _timeObj.getTime()+28800000
        }
    }, [breathArr, t]);

    useEffect(()=>{
        if(alertCheck && breathCheck && sleepCheck && sleepInfoCheck){
            let options = {
                width: 850,
                scale: 2,
                type: "png",
                svg: generateSVG(),
                constr: 'Chart',
                b64: true,
                outfile: `${resident.first_name}_${resident.last_name}_DailyReport.png`
            }
            ApiGo.postDaily_Report(resident.id, options)
            .then(()=>{})
            .catch(err=>{console.log(err);})
        }

        function generateSVG(){
            let svgArr = [];
            var svg = chartRef.current.chart.getSVG();
            svg = svg.replace('<svg', '<g transform="translate(16,460)"');
            svg = svg.replace('</svg>', '</g>');
            svg = svg.replace('Highcharts.com', '')
            svgArr.push(SVGformat.startTag)
            svgArr.push(SVGformat.SVGstyle)
            svgArr.push(SVGformat.backGround)
            svgArr.push(SVGformat.header(props.data, dateStr_1dayago, timeNow, comm_imgs.LOGO_COMPANY_LOGIN))
            svgArr.push(SVGformat.alert(t("HISTORY_RECORD.BED_STATUS"), alertArr))
            svgArr.push(SVGformat.sleep(t("HISTORY_RECORD.SLEEP_EFFICIENCY"), sleepTitle, sleepArr[0]))
            svgArr.push(SVGformat.breath(t("HISTORY_RECORD.BREATH_HIS" ), `${svg}`))
            svgArr.push(SVGformat.endTag)
            return svgArr.join('');
        }
    }, [alertCheck, breathCheck, sleepCheck, sleepInfoCheck])

    return(<div style={{'display':"none"}}><HighchartsReact highcharts={Highcharts} options={breath} ref={chartRef}/></div>);

}


function calculateYesterday(tstp){
    let a = tstp%86400000
    return tstp-a
}
function alertFilter(_alert) {
    let state1, state14, state217, state218, state12 = [0,0,0,0,0]
    state1 = _alert.filter(_a => _a.bedStateAlertLevel===2 && _a.bedState===1).length
    state14 = _alert.filter(_a => _a.bedStateAlertLevel===2 && _a.bedState===14).length
    state217 = _alert.filter(_a => _a.bedStateAlertLevel===2 && _a.bedState===217).length
    state218 = _alert.filter(_a => _a.bedStateAlertLevel===2 && _a.bedState===218).length
    state12 = _alert.filter(_a => _a.bedStateAlertLevel===2 && _a.bedState===12).length
    return [[state1, 1], [state14, 14], [state217, 217], [state218, 218], [state12, 12]]
}

export default PrintPage;